import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BottomNav from '../BottomNav';
import theme from '../theme';

const variants = {
  complete: {
    emoji: '🎉',
    title: 'Configurazione completata!',
    text: 'Il tuo account per ricevere pagamenti è stato configurato. Potrebbero volerci alcuni istanti prima che risulti attivo.',
    color: 'primary',
  },
  refresh: {
    emoji: '⏳',
    title: 'Sessione scaduta',
    text: 'Il link di configurazione è scaduto. Torna a Pagamenti per riprovare.',
    color: 'textPrimary',
  },
};

function OnboardingStatus() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status') === 'refresh' ? 'refresh' : 'complete';
  const v = variants[status];

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family, padding: 40, textAlign: 'center' }}>
      <div style={{ fontSize: 60, marginBottom: theme.spacing.lg }}>{v.emoji}</div>
      <h2 style={{ color: theme.colors[v.color] }}>{v.title}</h2>
      <p style={{ color: theme.colors.textSecondary }}>{v.text}</p>
      <button onClick={() => navigate('/pagamenti')} style={{
        background: theme.colors.primary, color: theme.colors.white, border: 'none',
        borderRadius: theme.radius.lg, padding: '14px 32px', fontSize: theme.font.size.xl, cursor: 'pointer', marginTop: theme.spacing.lg
      }}>Torna a Pagamenti</button>
      <BottomNav />
    </div>
  );
}

export default OnboardingStatus;